// extracted by mini-css-extract-plugin
export default {"container":"loader_container__hl4K4","loader":"loader_loader__nfHlH","rotation":"loader_rotation__yLY8q","circle":"loader_circle__7qOdR"};